/* eslint-disable  react/prop-types */

import React from 'react';

const VehicleIssuesIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="28" viewBox="0 0 32 28" fill="none">
    <path d="M20.5858 8.68896H11.3431C11.1207 8.68896 10.9047 8.76309 10.7292 8.89961L6.57816 12.1282C6.52618 12.1686 6.4704 12.2034 6.41216 12.2342C5.75879 12.5789 4.91318 13.189 3 13.189C1.4 13.189 1 13.8556 1 14.189V18.189C1 18.989 1.66667 19.189 2 19.189H30C30.5523 19.189 31 18.7414 31 18.1891V16.689C31 15.489 30.5 14.689 29 14.189L25.7492 13.2602C25.5858 13.2135 25.4369 13.1259 25.3168 13.0057L21.2929 8.98186C21.1054 8.79432 20.851 8.68896 20.5858 8.68896Z" stroke="#00619E" strokeWidth="2" strokeLinejoin="round"/>
    <circle cx="9.5" cy="19.189" r="2.5" fill="white" stroke="#00619E" strokeWidth="2"/>
    <circle cx="22.5" cy="19.189" r="2.5" fill="white" stroke="#00619E" strokeWidth="2"/>
    <ellipse cx="16" cy="3.18896" rx="6" ry="1.5" stroke="#00AED9" strokeWidth="2"/>
    <path d="M20 26.689C19.2502 25.5008 17.7404 24.689 16 24.689C14.2596 24.689 12.7498 25.5008 12 26.689" stroke="#00619E" strokeWidth="2" strokeLinecap="round"/>
  </svg>
);

export default VehicleIssuesIcon;
